export const SET_APP_IS_INACTIVE = "SET_APP_IS_INACTIVE";

export type SetAppIsInactive = {
    type: typeof SET_APP_IS_INACTIVE;
    payload: boolean;
};

export type AppIsInactiveActions = SetAppIsInactive;

export const setAppIsInactive = (payload: boolean): SetAppIsInactive => ({
    type: SET_APP_IS_INACTIVE,
    payload,
});
